import styled from "@emotion/styled";
import React, { PureComponent } from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { defaultFonts } from "../../../helpers/fonts";
import PbBarChartProps from "./PbBarChartProps.type";

const ChartContainer = styled.div({
  display: "flex",
  flexDirection: "column",
});

const LabelText45deg = styled.text({
  transform: "rotate(-45deg)",
});

const CustomChartLabel = (props) => {
  const { x, y, fill, value } = props;

  return (
    <LabelText45deg x={x} y={y} fontFamily={defaultFonts}>
      {value}
    </LabelText45deg>
  );
};

const PbBarChart = (props: PbBarChartProps) => {
  return (
    <ChartContainer style={{ height: props.height, width: props.width }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={props.width}
          height={props.height}
          data={props.data}
          margin={props.margin}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" angle={45} tickMargin={10} allowDuplicatedCategory allowDataOverflow interval={0}/>
          <YAxis />
          <Tooltip />
          <Legend />
          {props.dataKeys.map((dataKey, index) => {
            return (
              <Bar
                key={"char-bar-" + dataKey.key + "-" + index}
                dataKey={dataKey.key}
                fill={dataKey.hexColor}
              ></Bar>
            );
          })}
        </BarChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};

export default PbBarChart;
